import MiniProgramPage from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/subpackage/manager/project-detail.vue'
wx.createPage(MiniProgramPage)